import { render, staticRenderFns } from "./MtProductsList.vue?vue&type=template&id=54dc4f38&scoped=true&"
import script from "./MtProductsList.vue?vue&type=script&lang=js&"
export * from "./MtProductsList.vue?vue&type=script&lang=js&"
import style0 from "./MtProductsList.vue?vue&type=style&index=0&id=54dc4f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc4f38",
  null
  
)

export default component.exports